import { memo } from 'react'

interface RequiredMarkComponentProps {
  style?: { [key: string]: string }
}
const RequiredMarkComponent = ({ style }: RequiredMarkComponentProps) => (
  <sup style={{ color: '#EC5E57', ...style }}>*</sup>
)

export const RequiredMark = memo(RequiredMarkComponent)
